import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Card, Col, Container, Row } from "react-bootstrap";
import React, { Fragment, useEffect, useState } from "react";
import {
  createNewRole,
  fetchEditRole,
  fetchMenuList,
  fetchRoleList,
} from "../actions/role";
import { useNavigate, useParams } from "react-router-dom";

import AddIcon from "@mui/icons-material/Add";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import EditIcon from "@mui/icons-material/Edit";
import FormSystemInformation from "../components/Admin/Reusable/FormSystemInformation";
import InputField from "../components/Admin/Reusable/InputField";
import SelectStatus from "../components/Admin/Reusable/Form/SelectStatus";
import SubmitButtonForm from "../components/Admin/Reusable/Form/SubmitButtonForm";
import { basicFormValidationHandler } from "../utils";
import { fetchCountryFormList } from "../actions/country";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import FormTitleMain from "../components/Admin/Reusable/FormTitleMain";

const RoleAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  //breadcrumb
  const translateForm = "rolesForm";
  const translateModule = "roles";
  const pageType = id ? "Edit" : "Add";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const initialState = {
    name: "",
    status: "ACTIVE",
  };

  const [data, setData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [selectedOptions, setSelectedOptions] = useState([]);

  const { countryFormList } = useSelector((state) => state.countryReducer);
  const { roleDetail, moduleList } = useSelector((state) => state.roleReducer);

  const handleInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  //pozvati podatke za drzave kako bi izlistali u selektu
  useEffect(() => {
    dispatch(fetchCountryFormList());
    dispatch(fetchMenuList());
  }, []);

  useEffect(() => {
    if (!id) {
      // Ako `id` ne postoji, očisti stanje za novu kreaciju
      setData(initialState);
    } else {
      // Ako `id` postoji, učitaj podatke za korisnika
      dispatch(fetchRoleList(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (roleDetail && id) {
      if (roleDetail && roleDetail.menus) {
        const options = moduleList
          .filter((module) =>
            roleDetail.menus.some((menu) => menu.id === module.id)
          )
          .map((module) => module.id);
        setSelectedOptions(options);
      }
      setData({
        ...data,
        name: roleDetail.name || "",
        status: roleDetail.status || "ACTIVE",
        createdAt: roleDetail.createdAt || "",
        updatedAt: roleDetail.updatedAt || "",
      });
    }
  }, [roleDetail, id]);

  const clientValidationHandler = () => {
    const { name } = data;

    let errorsObject = {};

    errorsObject = basicFormValidationHandler({
      name,
    });

    setErrors(errorsObject);

    if (!isEmpty(errorsObject))
      toast.error("Morate popuniti sva obavezna polja", { theme: "colored" });
    return !isEmpty(errorsObject);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    if (clientValidationHandler()) {
      setIsSubmitting(false);
      return;
    }
    data.menus = selectedOptions;
    if (id) {
      data.id = id;
      dispatch(fetchEditRole(data, navigate)).finally(() => {
        setIsSubmitting(false);
      });
    } else {
      dispatch(createNewRole(data, navigate)).finally(() => {
        setIsSubmitting(false);
      });
    }
  };

  const handleCheckboxChange = (event, option) => {
    if (event.target.checked) {
      setSelectedOptions([...selectedOptions, option]);
    } else {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    }
  };

  return (
    <Fragment>
      <Breadcrumb
        breadcrumbItems={breadcrumbItems}
        type={translateModule}
        id={id}
        extraTitle={roleDetail && roleDetail.name}
        pageType={pageType}
      />
      <Container>
        <Row>
          <Col lg={12}>
            <form onSubmit={handleSubmit} noValidate>
              <Row>
                <Col lg={12}>
                  <div className="text-end mb-2">
                    <SubmitButtonForm id={id} disabled={isSubmitting} />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col lg={9}>
                  <Card>
                    <Card.Header>
                      <FormTitleMain />
                    </Card.Header>
                    <Card.Body>
                      <div className="product-holder-admin-left-side-text">
                        <Row>
                          <Col lg={12} md={12} xs={12} className="mb-3">
                            <InputField
                              label={t("roleName.name")}
                              name="name"
                              value={data.name}
                              onChange={handleInputChange}
                              error={errors}
                              errorsHandler={setErrors}
                              fullWidth
                              size="small"
                              required
                            />
                          </Col>
                        </Row>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={3}>
                  <Row>
                    <Col lg={12}>
                      <SelectStatus
                        data={data}
                        handleInputChange={handleInputChange}
                      />
                    </Col>
                    <Col lg={12}>
                      <Card>
                        <Card.Header>{t("global.modules")}</Card.Header>
                        <Card.Body>
                          <FormGroup>
                            <InputLabel id="demo-simple-select-label">
                              {t("global.modules")}
                            </InputLabel>
                            {moduleList?.map((option, index) => (
                              <FormControlLabel
                                key={index}
                                control={
                                  <Checkbox
                                    checked={selectedOptions?.includes(
                                      option.id
                                    )}
                                    onChange={(e) =>
                                      handleCheckboxChange(e, option.id)
                                    }
                                  />
                                }
                                label={option.name}
                              />
                            ))}
                          </FormGroup>
                        </Card.Body>
                      </Card>
                    </Col>
                    {id && (
                      <Col lg={12}>
                        <FormSystemInformation data={data} />
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </form>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default RoleAdd;
